import { allpeepPayloadEndpoint } from './helpers.js';
export const analytics = (rawClient) => ({
    recordClicks: allpeepPayloadEndpoint(rawClient, '/analytics/clicks'),
});
